import React from "react";
import styled from "styled-components";
import { colors } from "theme";
import RenderContacts from "./RenderContacts";
import { Ptag } from "components/core";
import RenderEscalation from "./RenderEscalation";

function Level({ data, cashlessClaim }) {
  const contactDetail = (contactDetails, index) => {
    return (
      <div>
        <OuterDiv
          style={{
            background: "white",
          }}
        >
          <>
            {data.length > 1 && (
              <LevelTag>
                <Ptag color="white" fontSize="12px">
                  Level {index + 1}
                </Ptag>
              </LevelTag>
            )}
            {contactDetails.map((value, index) => {
              const contact_length = contactDetails.length;
              return (
                <>
                  {cashlessClaim == "cashless" ? (
                    <RenderContacts
                      claim={value}
                      index={index}
                      contact_length={contact_length}
                    />
                  ) : (
                    <RenderEscalation
                      claim={value}
                      index={index}
                      contact_length={contact_length}
                    />
                  )}
                </>
              );
            })}
          </>
        </OuterDiv>
      </div>
    );
  };
  return (
    <ParentDiv>
      {data.map((value, index) => {
        return contactDetail(value, index);
      })}
    </ParentDiv>
  );
}

export default Level;

const OuterDiv = styled.div`
  background-color: ${colors.newCardBgColor};
  padding: 4rem 2rem 3rem 3rem;
  position: relative;
  display: flex;
  border-radius: 10px;
`;

const LevelTag = styled.div`
  width: 80px;
  height: 25px;
  background-color: #65179a;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  top: 0px;
`;

const ParentDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  top: 0;
`;
